import React, { useEffect, useState } from "react";
import FullScreenMap from "../components/map/FullScreenMap";
import Dashboard from "../components/Dashboard/Dashboard";
import Sidebar from "../components/sidebar/Sidebar";
import "../pages/home/home.scss";

// The original station board: the full-screen alarm map while an alarm is
// active, otherwise the rotating dashboard (memos, duty crew, units, media,
// calendar, leadership, radar) beside the weather/clock sidebar.
//
// Legacy accounts render it with no `agency` and each part resolves the agency
// from the signed-in user's profile, as it always has. A Studio board built
// from the Legacy template passes its own agency (per-board accounts have no
// user profile) and gets exactly the same components, reading the same data:
// the agency's classic Station Board settings.
export const LegacyBoard = ({ agency }) => {
  const [selectedTab, setSelectedTab] = useState("map");
  const [alarms, setAlarms] = useState([]);

  useEffect(() => {
    setSelectedTab(alarms.length > 0 ? "map" : "dashboard");
  }, [alarms]);

  return (
    <div className="homeContainer">
      <FullScreenMap
        agency={agency}
        alarms={alarms}
        setAlarms={setAlarms}
        onAlarmsChange={setAlarms}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      <Dashboard agency={agency} selectedTab={selectedTab} />
      <Sidebar agency={agency} />
    </div>
  );
};

// A Studio screen showing the legacy board. It takes the whole display, not a
// 16:9 grid cell, because the legacy layout is sized to the viewport.
export const LegacyBoardScreen = ({ agency }) => (
  <div className="home sb-legacy-board">
    <LegacyBoard agency={agency} />
  </div>
);

export default LegacyBoard;
